export const SUMMARY_LIMIT = 500;
export const SUMMARY_FETCH_DEBOUNCE_MS = 400;

export const DEFAULT_RUN_SUMMARY = {
  total: 0,
  completed: 0,
  failed: 0,
  startedAt: 'N/A',
  endedAt: 'N/A',
  byVersion: [],
  byScenario: [],
  byFlow: [],
  byFlowScenario: [],
  timeReport: [],
};

export const toBackendDate = (value) => {
  if (!value) return null;

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
};

export const getSummaryErrorMessage = (error) =>
  error?.response?.data?.message ||
  error?.response?.data?.detail ||
  error?.message ||
  'Failed to load run summary.';

export const getRunTimestamp = (run, key) => {
  const date = new Date(run?.[key]);
  return Number.isNaN(date.getTime()) ? null : date.getTime();
};

export const getFailedRunsDateRange = (runs = []) => {
  const startedAtTimes = runs.map((run) => getRunTimestamp(run, 'startedAt')).filter(Boolean);
  const finishedAtTimes = runs.map((run) => getRunTimestamp(run, 'finishedAt')).filter(Boolean);

  return {
    startDate: startedAtTimes.length ? Math.min(...startedAtTimes) : null,
    endDate: finishedAtTimes.length ? Math.max(...finishedAtTimes) : null,
  };
};

export const toDateTimeLocalValue = (timestamp) => {
  if (!timestamp) return '';

  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '';

  const pad = (value) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(
    date.getHours(),
  )}:${pad(date.getMinutes())}`;
};
